
export const ApiList = () => {
    return {
        getSession:"getSession",
    }
}

export const DefaultParameters = () => {
    return {
        ProductURL: "https://my.ipagent.ai",
        LoginRoute: "",
        SignupRoute: "/signup",
        Cookie: "ipagent.ai-user-access-token",
        Calendly: "https://calendly.com/ipagentai",

    }
}


export const HubspotInfo = {
    HubspotPortalID:    "21105117",
    PricingPlanFormID:  "66e02ad1-e514-4a1c-817b-27650034ccb6",
    RequestDemoFormID:  "28f4a1de-e66e-4c60-b3ac-ab4ec62afefa",
    NewsLetterFormID:   "8aab2b24-8072-432b-8542-2a1b2adc364d",
}